module.exports = __webpack_public_path__ + "img/modal_icon.10270d54.svg";